import 'fslightbox';

interface FsLightboxInstance {
	props: {
		sources: string[];
		captions: string[];
	};
	open: (index: number) => void;
}

declare global {
	interface Window {
		FsLightbox?: new () => FsLightboxInstance;
		fsLightboxInstances: Record<string, FsLightboxInstance>;
	}
}

const LIGHTBOX_TRIGGER_SELECTOR = '.image__lightbox-trigger[data-lightbox-group][data-lightbox-source]';

const bindLightboxButtons = () => {
	if (typeof window.FsLightbox !== 'function') {
		return;
	}

	const triggers = Array.from(document.querySelectorAll<HTMLElement>(LIGHTBOX_TRIGGER_SELECTOR));
	if (!triggers.length) {
		return;
	}

	const groupedTriggers = new Map<string, HTMLElement[]>();

	for (const trigger of triggers) {
		if (trigger.dataset.lightboxBound === 'true') {
			continue;
		}

		const group = trigger.dataset.lightboxGroup;
		if (!group) {
			continue;
		}

		if (!groupedTriggers.has(group)) {
			groupedTriggers.set(group, []);
		}

		groupedTriggers.get(group)!.push(trigger);
	}

	for (const [group, groupTriggers] of groupedTriggers.entries()) {
		const lightbox = new window.FsLightbox();

		lightbox.props.sources = groupTriggers.map((trigger: HTMLElement) => trigger.dataset.lightboxSource || '');
		lightbox.props.captions = groupTriggers.map((trigger: HTMLElement) => trigger.dataset.lightboxCaption || '');

		for (const trigger of groupTriggers) {
			trigger.dataset.lightboxBound = 'true';
			trigger.addEventListener('click', (event: MouseEvent) => {
				event.preventDefault();
				const index = groupTriggers.indexOf(trigger);
				lightbox.open(index >= 0 ? index : 0);
			});
		}

		window.fsLightboxInstances[group] = lightbox;
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', bindLightboxButtons);
} else {
	bindLightboxButtons();
}
